
export const path = {
  Login: "/login",
  PaperGenerate: "/paperGenerate",
  SectionWise: "/paperGenerate/manuallyGenerate/sectionWiseExamPaper",
  ManuallyGenerate: "/paperGenerate/manuallyGenerate/sectionWiseExamPaper/manuallyGenerate",
  QTypeWise: "/paperGenerate/manuallyGenerate/sectionWiseExamPaper/qTypeWise",
  QuestionSection: "/paperGenerate/manuallyGenerate/sectionWiseExamPaper/questionSection",
  Relpace: "/paperGenerate/manuallyGenerate/sectionWiseExamPaper/questionSection",
  WithoutSection: "/paperGenerate/manuallyGenerate/withoutSectionWisePaper",
  AutoGenerate: "/paperGenerate/autoGenerate",
  RandomGenerate: "/paperGenerate/randomGenerate",
  RandomGenerateQue: "/paperGenerate/randomGenerate/questions",
  PaperHistory: "/paperHistory",
  Profile: "/profile",
  ProfileInformation: "/profile/profileInfo",
  ReportedQuestions: "/profile/subjectHistory",
  QuestionReport: "/profile/questionReport",
  PdfPreview: "/pdfPreview",
  EditPaper: "/EditPaper",
  SamplePaper: "/paperGenerate/samplePaper",
};

export const HeadersPath = {
  SectionWise: 'Paper Generate > Manually Generate > Section Wise Exam Paper',
  withoutSection: 'Paper Generate > Manually Generate > Without Section Wise Paper',
  AutoGenerate: 'Paper Generate > Auto Generate',
  RandomGenerate: 'Paper Generate > Random Generate',
  Profile: 'Profile',
  PaperHistory: 'Paper History',
  SamplePaper: 'Paper Generate > Sample Paper',
}